import { Get_Workflows_By_Status } from "@/modules/crm/automation/graphql-queries";
import WF_signalr from "@/modules/crm/automation/workflow-signalr-constants";
import { Enums } from "@/services/dropdown-enums";
import { generateOptions } from "@/services/generic.methods";
import UseGql from "@/services/graph-ql/useGql";
import OnInitHub from "@/services/signal-R/on-receive-hook";
import useSignalRClient from "@/services/signal-R/signalr-hubs";
import { ToastTemplate } from "@/services/variables";
import { getAllRequests } from "@/store/slices/requests";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import useManageLead from "./useManageLead";
import { useRouter } from "next/router";

const {
  hubName,
  InvokeMethodNames: { stopWorkFlowLead },
  onReceiveMethodNames: { stopWorkFlowLeadResponse },
} = WF_signalr;

const useManageWorkflows = (props = {}) => {
  const { showResponse = false } = props;
  const { statuses, RTC } = useSignalRClient({ hubName });
  const [loading, setLoading] = useState(false);
  const requests = useSelector(getAllRequests);
  const { clearStateByMethods } = OnInitHub();
  const { getLeadWorkflows } = useManageLead();
  const [workflowName, setWorkflowName] = useState("");
  const { query } = useRouter(); // getting leadId from query params
  const leadId = Number(query?.id);

  //  listener
  useEffect(() => {
    if (showResponse) {
      let response = requests[stopWorkFlowLeadResponse];
      if (response && response.isSuccess) {
        toast.success(
          ToastTemplate.success(
            `The "${workflowName}" has been terminated for this lead`
          )
        );
        if (leadId) {
          getLeadWorkflows(leadId);
        }
      } else {
        if (response && response?.errors.length) {
          toast.error(ToastTemplate.error(response?.errors?.join(", ")));
        }
      }
      setWorkflowName("");
      clearStateByMethods([stopWorkFlowLeadResponse]);
    }
  }, [requests[stopWorkFlowLeadResponse]]);

  const handleStopLeadWorkflow = async (payload) => {
    const workflowHub = RTC[hubName];
    if (statuses[hubName] && workflowHub) {
      console.log("Form data::", payload);
      setWorkflowName(payload.name);
      // send data to signlr from here
      workflowHub
        .invoke(stopWorkFlowLead, payload)
        .then((data) => {
          console.log("Request sent with::", data);
          setTimeout(() => {
            // reset button state
            setLoading(true);
            if (payload.redirect) {
              // router.push(`/crm/leads`);
            }
          }, 2000);
        })
        .catch((error) => {
          setLoading(true);
          console.log("Error::", { ...error });
        });
    } else {
      setLoading(true);
    }
  };

  const { executeQuery: workflowListExQuery } = UseGql(Get_Workflows_By_Status);
  const [workflowsList, setWorkflowsList] = useState([]);
  const [workflowListLoading, setWorkflowListLoading] = useState(false);
  const pageSize = 100;

  const getWorkflowsList = (skip = 0, accumulatedWorkflows = []) => {
    setWorkflowListLoading(true);
    const payload = {
      workflowRunStatus: [
        Enums.WorkflowStatus.Ready,
        Enums.WorkflowStatus.Running,
        Enums.WorkflowStatus.Scheduled,
      ],
      skip,
      take: pageSize,
    };

    workflowListExQuery(payload)
      .then((response) => {
        const { items, totalCount } = response.data.workFlows;
        const updatedWorkflows = [
          ...accumulatedWorkflows,
          ...generateOptions(items, "name", "id"),
        ];

        if (totalCount > skip + pageSize) {
          // Fetch the next page
          getWorkflowsList(skip + pageSize, updatedWorkflows);
        } else {
          // All items have been fetched
          setWorkflowsList(updatedWorkflows);
          setWorkflowListLoading(false);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch workflows:", error);
        setWorkflowListLoading(false);
      });
  };

  return {
    handleStopLeadWorkflow,
    loading,
    getWorkflowsList,
    workflowsList,
    workflowListLoading,
  };
};

export default useManageWorkflows;
